// GlobalStyles.js
import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  /* 全局樣式定義 */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: "Roboto", sans-serif;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  ul, ol {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  ::-webkit-scrollbar {
    width: 8px; 
    height: 6px; 
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(97, 203, 201, 0.6); 
    border-radius: 16px; 
    border:2px solid gba(97, 203, 201, 1); 
  }

  ::-webkit-scrollbar-track {
    background: #F7F5F6;
    border-radius: 16px; 
  }
`;
